module.exports = __webpack_public_path__ + "static/img/logo_19.0ba32f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/logo_19.png
// module id = lYP/
// module chunks = 1